import React from "react";
import { ViewAssociatedPlansContainer } from "../../../containers";

const ViewAssociatedPlans = (props) => {
  return <ViewAssociatedPlansContainer {...props} />;
};

export default ViewAssociatedPlans;
